import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Flex,
  Heading,
  HStack,
  Image,
  Link,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import genshinImg from "../../../assets/raduno_genshin_24.jpg";

export default function RadunoGenshin() {
  return (
    <Card>
      <CardHeader>
        <Center>
          <VStack>
            <Heading size="md">Raduno di Genshin Impact</Heading>
            <Heading size="base">Domenica 26 maggio alle 14:00</Heading>
          </VStack>
        </Center>
      </CardHeader>
      <CardBody>
        <SimpleGrid
          columns={2}
          minChildWidth="300px"
          rowGap="20px"
          columnGap="20px"
        >
          <Center>
            <Link
              href={
                "https://facebook.com/events/s/raduno-genshin-impact/1113608699637003/"
              }
            >
              <Image src={genshinImg} maxW="300px" />
            </Link>
          </Center>
          <Box>
            <Text>Viaggiatori, attenzione! </Text>
            <br />
            <Text fontWeight="bold">
              Domenica 26 maggio 2024 alle 14:00 c'è stato il Raduno di Genshin
              Impact
            </Text>
            <br />
            Con una divertente
            <Text as={"span"} fontWeight="bold">
              "caccia al tesoro con quiz"
            </Text>
            .<br />
            Iscrizioni gratuite allo stand{" "}
            <Text as={"span"} fontWeight="bold">
              "la via del cosplay"
            </Text>
            .
            <Text>
              Una bella occasione per conoscere altri cosplayer, fare foto e
              passare del tempo in compagnia.
            </Text>
            <Text fontWeight="bold">Il divertimento è assicurato!</Text>
            <br />
            <Text>
              PH ufficiali dell'evento:{" "}
              <Link href={"https://www.instagram.com/lorenzo.penzo/"}>
                @lorenzo.penzo
              </Link>{" "}
              <Link href={"https://www.instagram.com/aikophotozz/"}>
                @aikophotozz
              </Link>
            </Text>
            <br />
            <Text>
              Per info:{" "}
              <Link href={"https://www.instagram.com/cospinny/"}>
                @cospinny
              </Link>{" "}
              <Link href={"https://www.instagram.com/theiaakrisi_cos/"}>
                @theiaakrisi_cos
              </Link>
            </Text>
            <br />
            <Text>
              Evento facebook:{" "}
              <Link
                href={
                  "https://facebook.com/events/s/raduno-genshin-impact/1113608699637003/"
                }
              >
                https://facebook.com/events/s/raduno-genshin-impact/1113608699637003/
              </Link>
            </Text>
            <br />
            <Text>"ad astra abyssosque"!✨</Text>
          </Box>
        </SimpleGrid>
      </CardBody>
    </Card>
  );
}
